import { render, staticRenderFns } from "./MyProfileRecents.vue?vue&type=template&id=90e5dc0c&"
import script from "./MyProfileRecents.vue?vue&type=script&lang=ts&"
export * from "./MyProfileRecents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports